import React from 'react';

export const ShimmerCategorias = () => {
  return (
    <div style={{ marginTop: '-7px', height: '65px', overflow: 'hidden' }}>
      <div className="shine shimmer-categoria" />
      <div className="shine shimmer-categoria" />
      <div className="shine shimmer-categoria" />
      <div className="shine shimmer-categoria" />
      <div className="shine shimmer-categoria" />
      <div className="shine shimmer-categoria" />
      <div className="shine shimmer-categoria" />
    </div>
  );
};
